import { Range } from 'slate';
import { Map } from 'immutable';

const lastPositionPlugin = () => ({
  onBlur: (event, editor, next) => {
    const lastPosition = editor.value.selection.toJSON();
    const lastPositionPluginData = editor.value.data.get('lastPositionPlugin') || Map({ lastPosition: null });

    editor.setData(editor.value.data.set(
      'lastPositionPlugin',
      lastPositionPluginData.set('lastPosition', lastPosition)
    ));

    next();
  },
  queries: {
    getLastPosition: editor => {
      const lastPosition = editor.value.getIn(['data', 'lastPositionPlugin', 'lastPosition']);
      if (lastPosition) {
        return Range.fromJSON(lastPosition);
      }
      return null;
    },
  },
});

export default lastPositionPlugin;
